<div class="opcode-list-wrapper">
    <div class="opcode-panel">
      
      <div class="panel-left" id="opCodesListSection">
        <form [formGroup]="opCodeListForm">
          <div formGroupName="onlineOpCodesForm" class="list-opcodes online-opcodes">
            <div class="list-title">
              {{ 'opcodeServiceManagement.onlineOpcodes' | translate }} <span>({{onlineOpCodesCount}})</span>
            </div>
            <div class="list-opcode-container">
              <div class="search-form">
                <mat-form-field class="example-full-width" appearance="outline">
                  <input type="text" formControlName="searchQuery" matInput placeholder="{{ 'opcodeServiceManagement.searchOpCode' | translate }}">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
              </div>
              <div class="online-opcodes-sort-by d-flex" [ngClass]="'sort-' + sortOrder">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'opcodeServiceManagement.show' | translate }}</mat-label>
                  <mat-select formControlName="sortBy">
                    <mat-option value="alpha">{{ 'opcodeServiceManagement.sortBy' | translate }} - {{ 'opcodeServiceManagement.alphabetical' | translate }}</mat-option>
                    <mat-option value="price">{{ 'opcodeServiceManagement.sortBy' | translate }} - {{ 'opcodeServiceManagement.price' | translate }}</mat-option>
                    <mat-option value="aspOnly">{{ 'opcodeServiceManagement.aspServiceCodesOnly' | translate }}</mat-option>
                    <mat-option value="dmsOnly">{{ 'opcodeServiceManagement.dmsOpcodesOnly' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <asp-icon [title]="sortOrder + 'ending'" name="sort-asc-desc.svg" width="1.5rem" height="1.5rem"
                  class="m-auto cursor-pointer" (click)=onSortOrderChange()></asp-icon>
              </div>
                <div id="online-opcodes" class="opcodes-list">
                  <div *ngIf="onlineOpcodesSortBy === 'alpha' || onlineOpcodesSortBy === 'price' ">
                  <multi-drag-drop class="online-opcodes-drag-block" emptyText="{{ 'otherTexts.thereAreNoServicesToDisplay' | translate }}"
                    [items]="onlineOpCodes" (itemsRemoved)="itemsRemoved($event, 1)"
                    (itemsAdded)="itemsAdded($event, 1)" (itemsUpdated)="itemsUpdated($event, 1)"
                    (selectionChanged)="selectionChanged($event, 1)">
                    <ng-template let-item>
                      <div class="opcode">
                        <div class="opcode-name">
                          <span>{{item.displayName}}</span>
                          <span *ngIf="item.isAspCreated" title="{{ 'opcodeServiceManagement.aspServiceCode' | translate }}" class="created">
                            {{ 'opcodeServiceManagement.aspServiceCode' | translate }}</span>
                        </div>
                        <div class="opcode-desc">{{item.description}}</div>
                        <div *ngIf="item.pricing" class="price-and-discount">• {{'opcodeServiceManagement.price:' | translate}} {{item?.pricing?.dms}} 
                          • {{'opcodeServiceManagement.discount:' | translate}} {{item.pricing?.discount?.price}}</div>
                          <div *ngIf="!item.pricing" class="price-and-discount">{{'opcodeServiceManagement.priceNotSet' | translate}}</div>
                      </div>
                    </ng-template>
                  </multi-drag-drop>
                </div>
                <div id="asp-opcodes" class="asp-opcodes"
              *ngIf="onlineOpcodesSortBy === 'aspOnly'">
              <multi-drag-drop class="asp-service-codes-list" emptyText="{{ 'otherTexts.thereAreNoAspServiceCodesToDisplay' | translate }}"
                [items]="aspOnlineOpCodes" (itemsRemoved)="itemsRemoved($event, 2)"
                (itemsAdded)="itemsAdded($event, 2)" (itemsUpdated)="itemsUpdated($event, 2)"
                (selectionChanged)="selectionChanged($event, 2)">
                <ng-template let-item>
                  <div class="opcode">
                    <div class="opcode-name">
                      <span>{{item.displayName}}</span>
                      <span *ngIf="item.isAspCreated" title="{{ 'opcodeServiceManagement.aspServiceCode' | translate }}" class="created">
                        {{ 'opcodeServiceManagement.aspServiceCode' | translate }}</span>
                    </div>
                    <div class="opcode-desc">{{item.description}}</div>
                    <div *ngIf="item.pricing" class="price-and-discount">• {{'opcodeServiceManagement.price:' | translate}} {{item?.pricing?.dms}} 
                      • {{'opcodeServiceManagement.discount:' | translate}} {{item.pricing?.discount?.price}}</div>
                      <div *ngIf="!item.pricing" class="price-and-discount">{{'opcodeServiceManagement.priceNotSet' | translate}}</div>
                  </div>
                </ng-template>
              </multi-drag-drop>
            </div>
            <div id="dms-opcodes" class="dms-opcodes"
            *ngIf="onlineOpcodesSortBy === 'dmsOnly'">
            <multi-drag-drop class="dms-service-codes-list" emptyText="{{ 'otherTexts.thereAreNoServicesToDisplay' | translate }}"
              [items]="dmsOpCodes" (itemsRemoved)="itemsRemoved($event, 3)"
              (itemsAdded)="itemsAdded($event, 3)" (itemsUpdated)="itemsUpdated($event, 3)"
              (selectionChanged)="selectionChanged($event, 3)">
              <ng-template let-item>
                <div class="opcode">
                  <div class="opcode-name">
                    <span>{{item.displayName}}</span>
                    <span *ngIf="item.isAspCreated" title="{{ 'opcodeServiceManagement.aspServiceCode' | translate }}" class="created">
                      {{ 'opcodeServiceManagement.aspServiceCode' | translate }}</span>
                  </div>
                  <div class="opcode-desc">{{item.description}}</div>
                  <div *ngIf="item.pricing" class="price-and-discount">• {{'opcodeServiceManagement.price:' | translate}} {{item?.pricing?.dms}} 
                    • {{'opcodeServiceManagement.discount:' | translate}} {{item.pricing?.discount?.price}}</div>
                    <div *ngIf="!item.pricing" class="price-and-discount">{{'opcodeServiceManagement.priceNotSet' | translate}}</div>
                </div>
              </ng-template>
            </multi-drag-drop>
          </div>
                </div>
            </div>
          </div>
          <div class="arrow-container">
            <span [ngClass]="selectedOpcodeListFromTxm.length > 0 || selectedOpcodeListFromTxmRecommended.length > 0
                        || selectedOpcodeListFromTxmOther.length > 0 || selectedOpcodeListFromTxmAsp.length > 0 ? '' : 'hide-content'" class="selection-text mb-2">{{ (selectedOpcodeListFromTxm.length + selectedOpcodeListFromTxmRecommended.length
                            + selectedOpcodeListFromTxmOther.length+ selectedOpcodeListFromTxmAsp.length) + ('opcodeServiceManagement.selected' | translate)}}</span>
            <asp-icon class="indicator-height mb-2" name="move-left.svg" color="inherit" [ngClass]="selectedOpcodeListFromTxm.length > 0 || selectedOpcodeListFromTxmRecommended.length > 0
                        || selectedOpcodeListFromTxmOther.length > 0 || selectedOpcodeListFromTxmAsp.length > 0 ? 'highlight' : ''"
              (click)="updateServiceStatus(false)"></asp-icon>
            <asp-icon class="indicator-height inverse mb-2" name="move-left.svg" color="inherit"
              [ngClass]="selectedOpcodeListFromOnline.length > 0 || selectedAspOpcodeListFromOnline.length > 0
              || selectedDmsOpcodeListFromOnline.length > 0   ? 'highlight' : 'no-update'" (click)="updateServiceStatus(true)">
            </asp-icon>
            <span [ngClass]="selectedOpcodeListFromOnline.length > 0 || selectedAspOpcodeListFromOnline.length > 0
              || selectedDmsOpcodeListFromOnline.length > 0 ? '' : 'hide-content'"
              class="selection-text">{{ selectedOpcodeListFromOnline.length + selectedAspOpcodeListFromOnline.length +
                 selectedDmsOpcodeListFromOnline.length + ('opcodeServiceManagement.selected' | translate)}}</span>
          </div>
          <div formGroupName="txmOpCodesForm" class="list-opcodes txm-opcodes">
            <div class="list-title">
              {{ 'opcodeServiceManagement.txmOpcodes' | translate}} <span>({{(txmOpcodes.length)}})</span>
              <div class="title-button" style="float: right;" *ngIf="false">
                <button title="{{ 'opcodeServiceManagement.setupOpcodeToCaptureUnlistedServices' | translate}}" (click)=updateMiscOpCode() class='refresh' type="button"><span>{{ 'opcodeServiceManagement.setupMiscOpcode' | translate}}</span></button>
              </div>
            </div>
            <div class="list-opcode-container">
              <div class="online-opcodes-sort-by d-flex">
                <mat-form-field appearance="outline">
                  <mat-label>{{'opcodeServiceManagement.show' | translate }}</mat-label>
                  <mat-select formControlName="showOpCodes">
                    <mat-option value="all">{{'opcodeServiceManagement.all' | translate }}</mat-option>
                    <mat-option value="recommended">{{'opcodeServiceManagement.recommended' | translate }}</mat-option>
                    <mat-option value="aspOnly">{{ 'opcodeServiceManagement.aspServiceCodes' | translate }}</mat-option>
                    <mat-option value="other">{{'opcodeServiceManagement.other' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="txm-opcodes-list txm-opcodes-container">
              <div id="txm-online-opcodes" class="txm-online-opcodes"
                *ngIf="txmShowOpCodes === 'all'">
                <multi-drag-drop class="txm-online-opcodes-list" emptyText="{{ 'otherTexts.thereAreNoTxmServicesToDisplay' | translate }}"
                  [items]="txmOpcodes" (itemsRemoved)="itemsRemoved($event, 4)"
                  (itemsAdded)="itemsAdded($event, 4)" (itemsUpdated)="itemsUpdated($event, 4)"
                  (selectionChanged)="selectionChanged($event, 4)">
                  <ng-template let-item>
                    <div class="opcode">
                      <div class="opcode-name">
                        <span>{{item.displayName}}</span>
                        <span *ngIf="item.isAspCreated" title="{{ 'opcodeServiceManagement.aspServiceCode' | translate }}" class="created">
                          {{ 'opcodeServiceManagement.aspServiceCode' | translate }}</span>
                      </div>
                      <div class="opcode-desc">{{item.description}}</div>
                      <div *ngIf="item.pricing" class="price-and-discount">• {{'opcodeServiceManagement.price:' | translate}} {{item?.pricing?.dms}} 
                        • {{'opcodeServiceManagement.discount:' | translate}} {{item.pricing?.discount?.price}}</div>
                        <div *ngIf="!item.pricing" class="price-and-discount">{{'opcodeServiceManagement.priceNotSet' | translate}}</div>
                    </div>
                  </ng-template>
                </multi-drag-drop>
              </div>
              <div id="asp-opcodes" class="asp-opcodes"
                *ngIf="txmShowOpCodes === 'aspOnly'">
                <multi-drag-drop class="txm-asp-service-codes-list" emptyText="{{ 'otherTexts.thereAreNoAspServiceCodesToDisplay' | translate }}"
                  [items]="aspTxmOnlineOpCodes" (itemsRemoved)="itemsRemoved($event, 5)"
                  (itemsAdded)="itemsAdded($event, 5)" (itemsUpdated)="itemsUpdated($event, 5)"
                  (selectionChanged)="selectionChanged($event, 5)">
                  <ng-template let-item>
                    <div class="opcode">
                      <div class="opcode-name">
                        <span>{{item.displayName}}</span>
                        <span *ngIf="item.isAspCreated" title="{{ 'opcodeServiceManagement.aspServiceCode' | translate }}" class="created">
                          {{ 'opcodeServiceManagement.aspServiceCode' | translate }}</span>
                      </div>
                      <div class="opcode-desc">{{item.description}}</div>
                      <div *ngIf="item.pricing" class="price-and-discount">• {{'opcodeServiceManagement.price:' | translate}} {{item?.pricing?.dms}} 
                        • {{'opcodeServiceManagement.discount:' | translate}} {{item.pricing?.discount?.price}}</div>
                        <div *ngIf="!item.pricing" class="price-and-discount">{{'opcodeServiceManagement.priceNotSet' | translate}}</div>
                    </div>
                  </ng-template>
                </multi-drag-drop>
              </div>
              <div id="txm-recommended-opcodes" class="txm-recommended-opcodes"
                *ngIf="txmShowOpCodes === 'recommended'">
                <multi-drag-drop class="txm-recommended-opcodes-list" emptyText="{{ 'otherTexts.thereAreNoRecommendedServicesToDisplay' | translate }}"
                  [items]="txmRecommendedOnlineOpCodes" (itemsRemoved)="itemsRemoved($event, 6)"
                  (itemsAdded)="itemsAdded($event, 6)" (itemsUpdated)="itemsUpdated($event, 6)"
                  (selectionChanged)="selectionChanged($event, 6)">
                  <ng-template let-item>
                    <div class="opcode">
                      <div class="opcode-name">
                        <span>{{item.displayName}}</span>
                        <span *ngIf="item.isAspCreated" title="{{ 'opcodeServiceManagement.aspServiceCode' | translate }}" class="created">
                          {{ 'opcodeServiceManagement.aspServiceCode' | translate }}</span>
                      </div>
                      <div class="opcode-desc">{{item.description}}</div>
                      <div *ngIf="item.pricing" class="price-and-discount">• {{'opcodeServiceManagement.price:' | translate}} {{item?.pricing?.dms}} 
                        • {{'opcodeServiceManagement.discount:' | translate}} {{item.pricing?.discount?.price}}</div>
                        <div *ngIf="!item.pricing" class="price-and-discount">{{'opcodeServiceManagement.priceNotSet' | translate}}</div>
                    </div>
                  </ng-template>
                </multi-drag-drop>
              </div>
              <div id="txm-other-opcodes" class="txm-other-opcodes"
                *ngIf="txmShowOpCodes === 'other'">
                <multi-drag-drop class="txm-other-opcodes-list" emptyText="{{ 'otherTexts.thereAreNoTxmServicesToDisplay' | translate }}"
                  [items]="txmRegularOnlineOpCodes" [selected]="isSelected === 'online' ? true : false" (itemsRemoved)="itemsRemoved($event, 7)"
                  (itemsAdded)="itemsAdded($event, 7)" [index]="index" (itemsUpdated)="itemsUpdated($event, 7)"
                  (selectionChanged)="selectionChanged($event, 7)" (clearAspSelected)="clearAspSelected($event)">
                  <ng-template let-item>
                    <div class="opcode">
                      <div class="opcode-name">
                        <span>{{item.displayName}}</span>
                        <span *ngIf="item.isAspCreated" title="{{ 'opcodeServiceManagement.aspServiceCode' | translate }}" class="created">
                          {{ 'opcodeServiceManagement.aspServiceCode' | translate }}</span>
                      </div>
                      <div class="opcode-desc">{{item.description}}</div>
                      <div *ngIf="item.pricing" class="price-and-discount">• {{'opcodeServiceManagement.price:' | translate}} {{item.pricing?.dms}} • {{'opcodeServiceManagement.discount:' | translate}}
                        {{(item.pricing?.discount?.price) ? item.pricing?.discount?.price : '-'}}</div>
                      <div *ngIf="!item.pricing" class="price-and-discount">{{'opcodeServiceManagement.priceNotSet' | translate}}</div>
                    </div>
                  </ng-template>
                </multi-drag-drop>
              </div>
            </div>
            </div>
           
          </div>
        </form>
      </div>
  
      
    </div>
  
  </div>
  